module.exports = __webpack_public_path__ + "static/unbreakable-zack-collie-5281d942a2c5746b1061d27a05a57b41.jpg";